var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
import React from "react";
import classNames from "classnames";
import { Row, Col } from "@riseart/antd-provider";
import { EmbeddedMedia } from "@riseart/common";
import { imgGalleryCls, imgGalleryThumbnailListCls, imgGalleryColumnCls, imgGalleryClickableItemCls, imgGalleryMediaListCls, screenLarge } from "./Gallery.less";
var screenLg = parseInt(screenLarge, 10);
var handleClick = /* @__PURE__ */ __name(function handleClick2(idx, func) {
  return function(e) {
    func(idx, e);
  };
}, "handleClick");
var ArtGallery = /* @__PURE__ */ __name(function ArtGallery2(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, _ref$images = _ref.images, initialImages = _ref$images === void 0 ? [] : _ref$images, _ref$media = _ref.media, media = _ref$media === void 0 ? [] : _ref$media, ActionsComponent = _ref.actions, _ref$imgRenderer = _ref.imgRenderer, imgRenderer = _ref$imgRenderer === void 0 ? null : _ref$imgRenderer, _ref$onClickItem = _ref.onClickItem, onClickItem = _ref$onClickItem === void 0 ? null : _ref$onClickItem;
  var images = _toConsumableArray(initialImages);
  var firstImage = images.shift();
  var windowWidth = typeof window !== "undefined" ? window.innerWidth : screenLg;
  var loadSingleColumn = windowWidth < screenLg;
  var imageColumns = images.reduce(function(result, i, k) {
    var imageHeight = i && i.props && i.props.image && i.props.image.height || i.props.height || 0;
    var columnIndex = !loadSingleColumn && result[0].height > result[1].height ? 1 : 0;
    result[columnIndex].items.push(/* @__PURE__ */ React.createElement("div", _extends({
      key: k,
      className: classNames(_defineProperty({}, imgGalleryClickableItemCls, onClickItem))
    }, onClickItem ? {
      onClick: handleClick(k + 1, onClickItem)
    } : {}), imgRenderer ? imgRenderer(i, k, columnIndex) : i));
    result[columnIndex].height += imageHeight;
    return result;
  }, [{
    height: 0,
    items: []
  }, {
    height: 0,
    items: []
  }]);
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(imgGalleryCls, className)
  }, /* @__PURE__ */ React.createElement("div", _extends({
    className: classNames(_defineProperty({}, imgGalleryClickableItemCls, onClickItem))
  }, onClickItem ? {
    onClick: handleClick(0, onClickItem)
  } : {}), firstImage), ActionsComponent && /* @__PURE__ */ React.createElement(ActionsComponent, {
    data: firstImage
  }), media && media.length ? /* @__PURE__ */ React.createElement("div", {
    className: imgGalleryMediaListCls
  }, media.map(function(_ref2) {
    var mediaId = _ref2.mediaId, mediaPlatform = _ref2.mediaPlatform;
    return /* @__PURE__ */ React.createElement(EmbeddedMedia, {
      platform: mediaPlatform,
      id: mediaId
    });
  })) : null, images.length ? /* @__PURE__ */ React.createElement(Row, {
    className: imgGalleryThumbnailListCls,
    type: "flex",
    justify: "space-between"
  }, imageColumns.map(function(_ref3, columnIdx) {
    var items = _ref3.items;
    return /* @__PURE__ */ React.createElement(Col, {
      key: columnIdx,
      lg: 12,
      span: 24,
      className: imgGalleryColumnCls
    }, items.map(function(image) {
      return image;
    }));
  })) : null);
}, "ArtGallery");
export {
  ArtGallery
};
